<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts" setup>
import { computed, type HTMLAttributes } from 'vue'

import { cn, isVisible } from '../../../lib/utils'
import type { Testable } from '../../../main'
import { ListItem, type ListItemInterface } from '.'

defineOptions({ inheritAttrs: false })

export interface ListProperties extends Testable {
  items?: ListItemInterface[]
  collapsed?: boolean
  level?: number
  class?: HTMLAttributes['class']
}

const properties = defineProps<ListProperties>()

type ListModel = never

type ListEmits = never

type ListExpose = never

type ListSlots = never

export type ListTypes = {
  model: ListModel
  properties: ListProperties
  emits: ListEmits
  expose: ListExpose
  slots: ListSlots
}

const visibleItems = computed(() => {
  return properties.items?.filter((item) => isVisible(item))
})

//
</script>

<template>
  <div :class="cn('atabix-list', properties.class)" :data-test>
    <ListItem
      v-for="(item, index) in visibleItems"
      :key="index"
      :active="item.active"
      :collapsed="collapsed"
      :data-test="item.dataTest"
      :item="item"
      :level="level"
    />
  </div>
</template>

<style lang="scss">
.atabix-list {
  @apply flex;
  @apply gap-1;
  @apply flex-col;
  @apply w-auto;
}
</style>
